module.exports = __webpack_public_path__ + "resources/img/react_native.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/react_native.png
// module id = 1103
// module chunks = 0